import { React, useState, useEffect } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  // useLocation,
} from 'react-router-dom'

//Components
// import LangSel from './langSelect'
// import Chatbot from './chatbot'
import ChatbotContainer from './chatbotContainer'
import WithNavigate from './withNavigate'
import Welcome from './welcome'
import BrandSel from './brandSelection'
import Stimuli from './videoStimuli'
import EndSurvey from './endSurvey'
import NotUserPage from './notUserPage'

// Utils
// import { getLocation } from '../data/location'
function Layout() {
  const [brand, setBrand] = useState('')
  const [language, setlang] = useState('en')
  const [socDis, setSocDis] = useState('')
  const [catego, setCatego] = useState('')
  const [rgpd, setRgpd] = useState('yes')
  const [userName, setName] = useState('')
  const [userId, setUserId] = useState('')
  const [brandUsed, setUsed] = useState('')
  const [answers, setAns] = useState({})
  const [redirect, setRedir] = useState(false)
  const [send2video, set2Video] = useState(false)
  const [startSurvey, setStart] = useState('')
  const [endSurvey, setEnd] = useState('')

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('dataUser'))
    if (!user || !user.id) {
      setRedir(false)
    }
    if (user && !catego && !socDis) {
      setlang(user.lng || 'en')
      setName(user.name || '')
      setRgpd('yes')
      setUserId(user.id)
      setCatego(user.catego)
      setSocDis(user.socDis)
      const { cntry, age, rangeAge } = user
      setAns({
        ...answers,
        cntry: cntry,
        age: age,
        rangeAge: rangeAge,
        userId: user.id,
        catego: user.catego,
        socDis: user.socDis,
        language: user.lng,
        rgpd: 'yes',
        name: user.name,
      })
    }

    if (user && user.brand && !brand) {
      setBrand(user.brand || '')
      setUsed(user.brandUsed || '')
      set2Video(true)
    }
    // }
  }, [])

  return (
    <Router>
      <Routes>
        <Route
          path='/noSurvey'
          element={
            <WithNavigate>
              <NotUserPage setlang={setlang} lng={language} d />
            </WithNavigate>
          }
        />
        <Route>
          <Route
            path='/home'
            element={
              <WithNavigate>
                <Welcome
                  lng={language}
                  setlang={setlang}
                  user={userName}
                  brand={brand}
                  setSocDis={setSocDis}
                  setCatego={setCatego}
                  setRgpd={setRgpd}
                  setUserId={setUserId}
                  send2video={send2video}
                  setStart={setStart}
                  setAns={setAns}
                  answers={answers}
                />
              </WithNavigate>
            }
          />
          {/* <Route
            path='/:lng/:ctg/:sd/:id?'
            element={
              <WithNavigate>
                <Welcome
                  lng={language}
                  setlang={setlang}
                  user={userName}
                  brand={brand}
                  setSocDis={setSocDis}
                  setCatego={setCatego}
                  setRgpd={setRgpd}
                  setUserId={setUserId}
                  send2video={send2video}
                  setStart={setStart}
                />
              </WithNavigate>
            }
          /> */}
        </Route>
        {!redirect && (
          <Route
            path='/brand'
            element={
              <WithNavigate>
                <BrandSel
                  lng={language}
                  setBrand={setBrand}
                  setlang={setlang}
                  user={userName}
                  brand={brand}
                  rgpd={rgpd}
                  setSocDis={setSocDis}
                  setCatego={setCatego}
                  catego={catego}
                  socDis={socDis}
                  setUsed={setUsed}
                  brandUsed={brandUsed}
                  startSurvey={startSurvey}
                />
              </WithNavigate>
            }
          />
        )}
        {!redirect && (
          <Route
            path='/video'
            element={
              <WithNavigate>
                <Stimuli
                  lng={language}
                  brand={brand}
                  setlang={setlang}
                  user={userName}
                />
              </WithNavigate>
            }
          />
        )}
        {!redirect && (
          <Route
            path='/survey'
            element={
              <WithNavigate>
                <ChatbotContainer
                  lng={language}
                  brand={brand}
                  setlang={setlang}
                  user={userName}
                  rgpd={rgpd}
                  userId={userId}
                  socDis={socDis}
                  brandUsed={brandUsed}
                  catego={catego}
                  answers={answers}
                  setAns={setAns}
                />
              </WithNavigate>
            }
          />
        )}
        {!redirect && (
          <Route
            path='/end'
            element={
              <WithNavigate>
                <EndSurvey
                  lng={language}
                  brand={brand}
                  setlang={setlang}
                  user={userName}
                  rgpd={rgpd}
                  userId={userId}
                  socDis={socDis}
                  brandUsed={brandUsed}
                  catego={catego}
                  answers={answers}
                  setAns={setAns}
                  startSurvey={startSurvey}
                  endSurvey={endSurvey}
                  setEnd={setEnd}
                />
              </WithNavigate>
            }
          />
        )}
        <Route
          exact
          path='survey_fr/:id'
          element={
            <WithNavigate>
              <ChatbotContainer
                lng={language}
                brand={brand}
                setlang={setlang}
                user={userName}
                rgpd={rgpd}
                userId={userId}
                socDis={socDis}
                brandUsed={brandUsed}
                catego={catego}
                d
              />
            </WithNavigate>
          }
        />
        <Route
          path='/noSurvey'
          element={
            <WithNavigate>
              <NotUserPage lng={language} setlang={setlang} d />
            </WithNavigate>
          }
        />

        <Route path='*' element={<Navigate to='/noSurvey' />} d />
      </Routes>
    </Router>
  )
}
export default Layout
